import * as actions from './actions'

const PreIngreso = {
  namespaced: true,
  actions,
}

export default PreIngreso
